module.exports = __webpack_public_path__ + "static/media/Avatars_Female-19.de7a77f4.png";